import React from 'react';

import { DateValue } from '@internationalized/date';

import {
  currencyString,
  expectedFundingDateTooltipContent,
  formatDate,
} from '@consumer-frontend/nc-utils';
import { Icon } from '@consumer-frontend/shared-ui';

import { NcReviewFields, NcReviewFieldT } from '../NcReviewFields';
import { NcTooltip } from '../NcTooltip';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/draw-request/review.scss';

export type NcReviewCashAdvanceFieldsPropsT = {
  accountLast4: string;
  availableCreditRemaining: number;
  bankAccountType: 'Checking' | 'Savings';
  bankName: string;
  depositedAmount: number;
  expectedFundingDate: DateValue;
};
export type NcReviewCashAdvanceFieldsT = React.FC<NcReviewCashAdvanceFieldsPropsT>;

export const NcReviewCashAdvanceFields: NcReviewCashAdvanceFieldsT = ({
  accountLast4,
  availableCreditRemaining,
  bankAccountType,
  bankName,
  depositedAmount,
  expectedFundingDate,
}) => {
  const depositedToContent = (
    <>
      {bankName}
      <br />
      {`${bankAccountType} Account (...${accountLast4})`}
    </>
  );

  const expectedFundingDateLabel = (
    <>
      <span>Expected Funding Date</span>
      <NcTooltip tooltipContent={expectedFundingDateTooltipContent}>
        <Icon className="expected-funding-label-icon" iconName="info-circle-fill" />
      </NcTooltip>
    </>
  );

  const cashAdvanceFields: NcReviewFieldT[] = [
    { label: 'Deposited Amount', value: currencyString(depositedAmount) },
    { label: 'Available Credit Remaining', value: currencyString(availableCreditRemaining) },
    {
      chromaticIgnore: true,
      label: expectedFundingDateLabel,
      value: formatDate(expectedFundingDate),
    },
    { label: 'Deposited To', value: depositedToContent },
  ];

  return <NcReviewFields fields={cashAdvanceFields} />;
};
